export const RankTypeEnum = {
  ACTIVE_VALUE: 6,
  DIRECT_PUSH: 7
}

export const tabColum = [
  {
    title: '活跃值总排行',
    key: RankTypeEnum.ACTIVE_VALUE
  },
  {
    title: '我的直推排行',
    key: RankTypeEnum.DIRECT_PUSH
  }
]

export const listTitleColum = [
  {
    title: '排名',
    key: 'rank',
    span: 6,
    align: 'left'
  },
  {
    title: '用户',
    span: 12,
    key: 'user',
    align: 'left'
  },
  {
    title: '活跃值',
    key: 'brisk',
    span: 6,
    align: 'center'
  }
]

export const BriskStatusEnum = {
  CHECK_ING: 1,
  CHECK_FAIL: 3,
  CHECK_SUCCESS: 2
}
